import React, {useRef, useState} from "react";
import {CompletePayroll} from "../../../../app/interfaces";
import PayrollDetailsView from "../PayrollDetailsView";
import {PreviewDocument, UploadPaySlipContainer, UploadInvoice} from "./styles";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {updatePayrollState} from "../../../../app/payroll/selectors";
import {downloadBase64File, FETCH_STATUS_LOADING, PAYROLL_STATUS_PAID} from "../../../../utils/constants";
import {isValidString} from "../../../../utils";
import {updatePayroll} from "../../../../app/payroll/actions";
import {PopupLoading, PrimaryButton} from "../../../../components";

import {ReactComponent as AttachmentIcon} from '../../../../assets/icons/clip_upload.svg'
import {ReactComponent as CloseIcon} from '../../../../assets/icons/close_rounded.svg'

const PayrollPendingPayslip = ({payroll} : {payroll: CompletePayroll}) => {

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const statusUpdate = useSelector(updatePayrollState)

    const [payslip, setPayslip] = useState<{ base64: string, file_name: string }>({
        base64: '',
        file_name: ''
    })

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setPayslip({
                    base64: reader.result as string,
                    file_name: file.name
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleRemoveFile = () => {
        setPayslip({
            base64: '',
            file_name: ''
        })
    }

    const handleDownloadPreview = () => {
        downloadBase64File(
            payslip.base64,
            payslip.file_name
        )
    }

    const validatePayslip = () => {
        return isValidString(payslip.base64) && isValidString(payslip.file_name)
    }

    const handleUploadPayslip = () => {
        dispatch(updatePayroll({
            payrollId: payroll._id,
            employeeId: payroll.eor_employee._id,
            payslip:  payslip.base64,
            status: PAYROLL_STATUS_PAID
        }) as any)
    }

    if (statusUpdate === FETCH_STATUS_LOADING) {
        return <PopupLoading isOpen={true}/>
    }

    return <>
        <UploadPaySlipContainer>
            <h1>{t('upload_payslip')}</h1>
            <h3>{t('upload_payslip_message')}</h3>
            <div className="upload_area">
                <input type='file' accept='.pdf,.jpeg,.jpg,.png' onChange={handleFileInputChange} ref={fileInputRef} style={{display: 'none'}}/>
                {
                    isValidString(payslip.base64) && isValidString(payslip.file_name) ?
                        <PreviewDocument>
                            <button onClick={handleDownloadPreview}>
                                {payslip.file_name}
                            </button>
                            <CloseIcon onClick={handleRemoveFile}/>
                        </PreviewDocument> :
                        <UploadInvoice onClick={handleUploadClick}>
                            <div className="icon"><AttachmentIcon/> </div>
                            <p>{t('upload_document')}</p>
                        </UploadInvoice>
                }
                <div className="submit">
                    <PrimaryButton disabled={!validatePayslip()} onClick={handleUploadPayslip}>{t('confirm')}</PrimaryButton>
                </div>
            </div>
        </UploadPaySlipContainer>
        <PayrollDetailsView payroll={payroll}/>
    </>
}

export default PayrollPendingPayslip;
